import type { Pinia } from 'pinia'

const storesOrder = [
  // no deps
  ['useragent', useUseragentStore] as const,
  ['settings', useSettingsStore] as const,
  ['toggler', useTogglerStore] as const,
  ['consent', useConsentStore] as const, // has `useTracking` dep, but only during `update()` fn call
  ['partner', usePartnerStore] as const, // params, cookies
  ['tracking', useTrackingStore] as const, // consent, params, cookies, gtag, ids
  ['confdata', useConfdataStore] as const, // params, useragent, partner
  ['ab', useABStore] as const, // params, confdata, ids
  ['usersurvey', useUserSurveyStore] as const, // ids, tracking
  ['bookmarks', useBookmarksStore] as const, // partner, confdata
  ['reviews', useReviewsStore] as const, // confdata, params
  ['flextrip', useFlexTripStore] as const, // params, ab
  ['popups', usePopupsStore] as const,
  // ['recommendations', useRecommendationsStore] as const,
] as const

function mutateStores(stores: Record<string, unknown>, pinia: Pinia) {
  for (const [name, storeFn] of storesOrder) {
    Object.assign(stores, { [name]: storeFn(pinia) })
  }
  return stores
}

const piniaStorePlugin = defineNuxtPlugin({
  name: 'stores',
  enforce: 'pre',
  dependsOn: ['pinia', 'app:i18n', 'app:params', 'app:ids', 'unleash:plugin'],
  setup(nuxtApp) {
    const $pinia = nuxtApp.$pinia as Pinia
    let $stores = {}
    Object.defineProperty(nuxtApp.vueApp, '$stores', { get: () => $stores })
    nuxtApp.provide('stores', $stores)
    mutateStores($stores, $pinia)
    $stores = Object.freeze($stores)
  },
})

export default piniaStorePlugin

interface StoresMap {
  useragent: ReturnType<typeof useUseragentStore>
  ab: ReturnType<typeof useABStore>
  bookmarks: ReturnType<typeof useBookmarksStore>
  confdata: ReturnType<typeof useConfdataStore>
  consent: ReturnType<typeof useConsentStore>
  popups: ReturnType<typeof usePopupsStore>
  flextrip: ReturnType<typeof useFlexTripStore>
  partner: ReturnType<typeof usePartnerStore>
  // recommendations: ReturnType<typeof useRecommendationsStore>
  reviews: ReturnType<typeof useReviewsStore>
  settings: ReturnType<typeof useSettingsStore>
  toggler: ReturnType<typeof useTogglerStore>
  tracking: ReturnType<typeof useTrackingStore>
  usersurvey: ReturnType<typeof useUserSurveyStore>
}

declare module '#app' {
  interface NuxtApp {
    $stores: StoresMap
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $stores: StoresMap
  }
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $stores: StoresMap
  }
}
